<template>
  <v-sheet class="page job-post">
    <v-row align-content="space-between">
      <v-col
        class="d-flex justify-space-between background"
        cols="12"
        sm="6"
        md="7"
      >
        <div class="body ml-10">
          <p class="text-h4">
            Show off your <strong>personality</strong> <br />
            and passion, alongside your professional skills
          </p>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        class="d-flex justify-space-between align-center"
      >
        <JobPostTeaser />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import JobPostTeaser from '@/components/JobPostTeaser';
import { authComputed } from '@/store/helpers';

export default {
  data() {
    return {};
  },
  components: { JobPostTeaser },
  computed: {
    ...authComputed,
  },
};
</script>

<style lang="scss">
.body {
  width: 250px;
}
.job-post {
  .background {
    background: url('https://hrng-assets.s3.amazonaws.com/guyflipped2ndpanel_252ecdc66b.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: bottom;
    background-position-x: right;

    /* min-height: 580px;
    max-height: 580px; */
    min-height: 300px;
  }
  @media only screen and (min-width: 600px) {
    background-position-x: left;
  }
}
</style>
